// extracted by mini-css-extract-plugin
export default {"container":"yh-z","blurb":"zh-z","links":"Ah-z"};